import { useLocation } from "react-router-dom";
import { Passenger } from "../../../../backend/src/models/bookingGuestDetails";
import { HotelType } from "../../../../backend/src/shared/types";
import { useEffect, useState } from "react";
import { useSearchContext } from "../../contexts/SearchContext";
import { useHotelContext } from "../../contexts/HotelContext";
import { fetchBookingByReference, getUsdToGbpExchangeRate, sendHoldBookingEmail, updateBookingStatus } from "../../api-client";
//import { BookingResponse } from "../../../../backend/src/models/bookingDetails";
import { useAppContext } from "../../contexts/AppContext";
import { AiFillStar } from "react-icons/ai";
import PageLoaderComponent from "../Common/PageLoaderSearch";
import { processBooking } from "../../utils/bookingUtils";

interface BookingDetailsProps {
  formData: any;
  onUpdate: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
  totalCost: number;
  adultCount: number;
  childCount: number;
  hotel: HotelType;
  reference?: string;
}

const BookingDetailFormComponent: React.FC<BookingDetailsProps> = ({
  formData,
  // hotel,
  onUpdate,
  onNext
  // adultCount, 
  // childCount
}) => {
  const location = useLocation();
  //const { selectedPlan, totalCost, depositPrice, fullPayment, selectedPrice } = formData;
  //const totalCount = adultCount + childCount;
  const { destId, responseToken, numAdults, numChilds, hotel } = location.state;
  const { checkIn, checkOut, adultCount, childCount, nights } = useSearchContext();
  const { selectedDeal, selectedRoom, roomName, roomType, grossPrice, discountPrice } = useHotelContext();
  const [confirmBookingLoading, setConfirmBookingLoading] = useState<boolean>(false);
  //const [booking, setBooking] = useState<BookingResponse | null>(null);
  const [rate, setRate] = useState<number | null>(null);
  const { user } = useAppContext();

  const adltCount = numAdults === undefined ? formData.formData.numAdults : numAdults;
  const chldCount = numChilds === undefined ? formData.formData.numChilds : numChilds;
  const destinationId = destId === undefined ? formData.formData.destId : destId;
  const responseTokenId = responseToken === undefined ? formData.formData.responseToken : responseToken;
  //const primaryGuest = primaryGuestName === undefined ? formData.formData.primaryGuestName : primaryGuestName;

  const [passengers, setPassengers] = useState<Passenger[]>(() => {
    // Load passengers from localStorage or initialize empty array
    const savedPassengers = localStorage.getItem("passengers");
    return savedPassengers
      ? JSON.parse(savedPassengers)
      : Array(adltCount + chldCount).fill({
        title: "",
        firstName: "",
        lastName: "",
        dateOfBirth: { day: "", month: "", year: "" },
        email: "",
        contactNumber: "",
        postcode: "",
        address: "",
        passportNumber: "",
        wheelChair: false,
      });
  });

  // const leadPassengerEmail = passengers[0].email;

  const [formSubmitted, setFormSubmitted] = useState<boolean>(() => {
    // Load formSubmitted state from localStorage or initialize as false
    const savedFormSubmitted = localStorage.getItem("formSubmitted");
    return savedFormSubmitted ? JSON.parse(savedFormSubmitted) : false;
  });

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("passengers");
      localStorage.removeItem("formSubmitted");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Save passengers to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("passengers", JSON.stringify(passengers));
  }, [passengers]);

  // Save formSubmitted state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("formSubmitted", JSON.stringify(formSubmitted));
  }, [formSubmitted]);

  const formatDate = (date: any) => {
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11 ? 'st' :
        day % 10 === 2 && day !== 12 ? 'nd' :
          day % 10 === 3 && day !== 13 ? 'rd' : 'th';

    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    return `${day}${suffix} ${month} ${year}`;
  };

  // function getCurrentDateTime() {
  //   const date = new Date();

  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const hours = String(date.getHours()).padStart(2, '0');
  //   const minutes = String(date.getMinutes()).padStart(2, '0');
  //   const seconds = String(date.getSeconds()).padStart(2, '0');

  //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  // }

  // const handleHoldHotel = async (booking: BookingResponse) => {
  //   if (!booking) {
  //     console.error("Cannot hold hotel: Booking is null");
  //     return;
  //   }

  //   try {
  //     await updateBookingStatus("hold", booking.reference, '');
  //     const getBooking = await getBookingDetails(booking.responseToken);
  //     await sendHoldBookingEmail(leadPassengerEmail!, getBooking!, 'hold');
  //     const detailsFromDb = await fetchBookingByReference(booking.reference);
  //     onUpdate({ detailsFromDb });
  //     onNext();
  //   } catch (error) {
  //     console.error("Failed to hold hotel:", error);
  //   }
  // };

  const fetchRate = async () => {
    try {
      const exchangeRate = await getUsdToGbpExchangeRate();
      setRate(exchangeRate);
    } catch (err: any) {
      console.error('Failed to fetch exchange rate:', err);
    }
  };

  useEffect(() => {
    fetchRate();
  }, []);

  const CheckIn = formatDate(new Date(checkIn));
  const CheckOut = formatDate(new Date(checkOut));

  const validGrossPrice = grossPrice ? parseFloat(grossPrice) : 0;
  const validDiscountPrice = discountPrice ? parseFloat(discountPrice) : 0;

  // Additional check to ensure parsed values are numbers; set to 0 if NaN
  const safeGrossPrice = isNaN(validGrossPrice) ? 0 : validGrossPrice;
  const safeDiscountPrice = isNaN(validDiscountPrice) ? 0 : validDiscountPrice;

  // Calculate the gross price with either a 4% or 5% increase based on the discount presence
  const modifiedGrossPriceNew = safeDiscountPrice > 0 ? safeGrossPrice * 1.04 : safeGrossPrice * 1.05;

  // Calculate the discount; if discount is 0, use 1% of the new gross price as the discount
  const finalDiscountPriceNew = safeDiscountPrice > 0 ? safeDiscountPrice * 1.04 : safeGrossPrice * 0.01;

  // Calculate the final room price subtracting the discount from the modified gross price
  // const roomPriceNew = modifiedGrossPrice - finalDiscountPrice;

  const totalCount = adultCount + childCount;

  const effectiveRate = rate ?? 0.82;

  const modifiedGrossPrice = modifiedGrossPriceNew * effectiveRate;
  const finalDiscountPrice = finalDiscountPriceNew * effectiveRate;
  const roomPriceNew = modifiedGrossPrice - finalDiscountPrice;

  //const isBigSavings = finalDiscountPrice === safeDiscountPrice;

  const [errors, setErrors] = useState<{ [key: number]: { [field in keyof Passenger]?: string } }>({});

  const validatePassenger = (passenger: Passenger, index: number) => {
    const newErrors: { [field in keyof Passenger]?: string } = {};

    if (!passenger.firstName) newErrors.firstName = "First name is required";
    if (!passenger.lastName) newErrors.lastName = "Last name is required";
    // if (!passenger.passportNumber) newErrors.passportNumber = "Passport number is required";

    if (index === 0 && !passenger.email && !passenger.contactNumber) {
      newErrors.email = "Either Email or Contact number is required for the lead passenger";
    }

    if (!passenger.dateOfBirth.day || !passenger.dateOfBirth.month || !passenger.dateOfBirth.year) {
      newErrors.dateOfBirth = "Complete date of birth is required";
    }

    return newErrors;
  };

  const handlePassengerChange = (index: number, field: keyof Passenger, value: any) => {
    const updatedPassengers = passengers.map((passenger, i) =>
      i === index ? { ...passenger, [field]: value } : passenger
    );
    setPassengers(updatedPassengers);

    if (errors[index]?.[field]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], [field]: '' },
      }));
    }
  };

  const handleProceed = async (event: React.FormEvent) => {
    event.preventDefault();
    
    // Validate passenger details
    const validationErrors = passengers.reduce((acc, passenger, index) => {
      const passengerErrors = validatePassenger(passenger, index);
      if (Object.keys(passengerErrors).length > 0) {
        acc[index] = passengerErrors;
      }
      return acc;
    }, {} as typeof errors);
  
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  
    setFormSubmitted(true);
    localStorage.setItem('formSubmitted', 'true');
  
    onUpdate({ formSubmitted: true, passengers });
  
    // ✅ Handle "Free Fare Hold" Booking (No Payment Required)
    if (formData.selectedPlan === "Free Fare Hold") {
      try {
        setConfirmBookingLoading(true);
  
        // Step 1: Create booking without payment
        const { bookingDetails } = await processBooking(
          destinationId,
          responseTokenId,
          //primaryGuest,
          selectedRoom,
          selectedDeal,
          passengers,
          user,
          passengers[0].email || '',
          0,
          formData.selectedPlan,
          formData.selectedPrice,
          totalCount
        );

        await updateBookingStatus("hold", bookingDetails.reference, "");
  
        const detailsFromDb = await fetchBookingByReference(bookingDetails.reference);
  
        await sendHoldBookingEmail(passengers[0].email || "", bookingDetails, "hold");

        onUpdate({ bookingFromDB: detailsFromDb });
        onNext();
      } catch (error) {
        console.error("Error processing Free Fare Hold booking:", error);
      } finally {
        setConfirmBookingLoading(false);
      }
    } else {
      // ✅ Normal booking process (Proceeds to Payment)
      //onUpdate({ bookingReference: booking?.reference})
      onNext();
    }
  };

  return (
    <>
      {confirmBookingLoading && (
        <PageLoaderComponent />
      )}
      {/* <input type="hidden" value={booking?.reference || ""} /> */}
      <div className="container mx-auto p-0">
        <div className='md:flex mt-8'>
          <div className='flex flex-col md:flex-row lg:flex-row gap-4 md:w-[750px] 2xl:w-[950px]'>
            <form onSubmit={handleProceed} className="grid grid-cols-1 gap-5 rounded-lg border border-slate-300 p-5">
              <span className="text-3xl font-bold">Confirm Your Details</span>

              <div className="bg-halo-pink-bg p-2 md:p-4 rounded-lg space-y-4">
                {passengers.map((passenger, index) => {
                  const isAdult = index < adltCount;
                  const passengerType = isAdult ? "Adult" : "Child";
                  const passengerIndex = isAdult ? index + 1 : index - adltCount + 1;

                  return (
                    <div key={index} className={`p-3 ${index === 0 ? 'bg-white rounded-lg' : 'bg-white rounded-lg'}`}>
                      <h3 className="text-lg font-semibold">
                        {index === 0 ? `${passengerType} ${passengerIndex} - Lead Passenger` : `${passengerType} ${passengerIndex}`}
                      </h3>
                      {index === 0 && <p className="text-sm text-gray-600">The lead passenger will receive all booking information.</p>}
                      <hr className="mb-4 mt-4" />

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="text-gray-700 text-sm font-bold">Title</label>
                          <select
                            value={passenger.title || ""}
                            onChange={(e) => handlePassengerChange(index, 'title', e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                            disabled={formSubmitted}
                          >
                            <option value="">Select</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Miss">Miss</option>
                            <option value="Ms">Ms</option>
                            <option value="Dr">Dr</option>
                          </select>
                        </div>

                        <div>
                          <label className="text-gray-700 text-sm font-bold">First Name <span className='text-xs text-gray-600 font-normal italic'>(Enter your first name as in your passport)</span></label>
                          <input
                            type="text"
                            value={passenger.firstName || ""}
                            onChange={(e) => handlePassengerChange(index, 'firstName', e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                            disabled={formSubmitted}
                          />
                          {errors[index]?.firstName && <p className="text-red-500 text-xs">{errors[index].firstName}</p>}
                        </div>

                        <div>
                          <label className="text-gray-700 text-sm font-bold">Last Name <span className='text-xs text-gray-600 font-normal italic'>(Enter your last name as in your passport)</span></label>
                          <input
                            type="text"
                            value={passenger.lastName || ""}
                            onChange={(e) => handlePassengerChange(index, 'lastName', e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                            disabled={formSubmitted}
                          />
                          {errors[index]?.lastName && <p className="text-red-500 text-xs">{errors[index].lastName}</p>}
                        </div>

                        {index === 0 && (
                          <>
                            <div>
                              <label className="text-gray-700 text-sm font-bold">E-mail Address</label>
                              <input
                                type="email"
                                value={passenger.email || ""}
                                onChange={(e) => handlePassengerChange(index, 'email', e.target.value)}
                                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                                disabled={formSubmitted}
                              />
                            </div>

                            <div>
                              <label className="text-gray-700 text-sm font-bold">Contact Number</label>
                              <input
                                type="text"
                                value={passenger.contactNumber || ""}
                                onChange={(e) => handlePassengerChange(index, 'contactNumber', e.target.value)}
                                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                                disabled={formSubmitted}
                              />
                            </div>
                          </>
                        )}

                        <div>
                          <label className="text-gray-700 text-sm font-bold">Passport Number <span className='text-xs text-gray-600 font-normal italic'>(Optional)</span></label>
                          <input
                            type="text"
                            value={passenger.passportNumber || ""}
                            onChange={(e) => handlePassengerChange(index, 'passportNumber', e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-pink-500"
                            disabled={formSubmitted}
                          />
                          {errors[index]?.passportNumber && <p className="text-red-500 text-sm">{errors[index].passportNumber}</p>}
                        </div>
                        <div>
                          <label className="text-gray-700 text-sm font-bold">Date of Birth</label>
                          <div className="flex gap-2">
                            <select
                              value={passenger.dateOfBirth.day || ""}
                              onChange={(e) => handlePassengerChange(index, 'dateOfBirth', { ...passenger.dateOfBirth, day: e.target.value })}
                              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                              disabled={formSubmitted}
                            >
                              <option value="">Day</option>
                              {[...Array(31).keys()].map(day => (
                                <option key={day + 1} value={day + 1}>{day + 1}</option>
                              ))}
                            </select>
                            <select
                              value={passenger.dateOfBirth.month || ""}
                              onChange={(e) => handlePassengerChange(index, 'dateOfBirth', { ...passenger.dateOfBirth, month: e.target.value })}
                              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                              disabled={formSubmitted}
                            >
                              <option value="">Month</option>
                              {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map(
                                (month, i) => (
                                  <option key={i} value={i + 1}>{month}</option>
                                )
                              )}
                            </select>
                            <select
                              value={passenger.dateOfBirth.year || ""}
                              onChange={(e) => handlePassengerChange(index, 'dateOfBirth', { ...passenger.dateOfBirth, year: e.target.value })}
                              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                              disabled={formSubmitted}
                            >
                              <option value="">Year</option>
                              {[...Array(100).keys()].map(year => (
                                <option key={2023 - year} value={2023 - year}>{2023 - year}</option>
                              ))}
                            </select>
                          </div>
                          {errors[index]?.dateOfBirth && <p className="text-red-500 text-sm">{errors[index].dateOfBirth}</p>}
                        </div>
                        <div>
                          <label className="text-gray-700 text-sm font-bold flex items-center gap-2">
                            Requires Wheelchair
                            <input
                              type="checkbox"
                              checked={passenger.wheelChair || false}
                              onChange={(e) => handlePassengerChange(index, "wheelChair", e.target.checked)}
                              className="form-checkbox h-5 w-5 text-pink-600"
                              disabled={formSubmitted}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Submit Button */}
              <div className="flex justify-end">
                {formData.selectedPlan === 'Free Fare Hold' ? (
                  <button
                    type="submit"
                    className="bg-halo-pink text-white p-2 font-bold hover:bg-pink-900 text-md w-full rounded-lg disabled:bg-gray-500"
                    disabled={formSubmitted || confirmBookingLoading}
                  >
                    {confirmBookingLoading ? 'Loading...' : 'Confirm'}
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="bg-halo-pink text-white p-2 font-bold hover:bg-pink-900 text-md w-full rounded-lg disabled:bg-gray-500"
                    disabled={formSubmitted || confirmBookingLoading}
                  >
                    {confirmBookingLoading ? 'Loading...' : 'Confirm'}
                  </button>
                )}
              </div>
            </form>
          </div>

          <div className='flex-[1_1_0%] md:ml-8 px-2 md:px-0 mb-6 mt-6 md:mt-0'>
            <div className="p-6 shadow-lg rounded-lg bg-white max-w-md mx-auto border-t border-gray-200 mb-6">
              <div className='mb-4'>
                <div className='flex items-center'>
                  <span className='mr-2 text-xs font-normal'>Hotel</span>
                  {Array.from({ length: hotel.starRating }).map((_, index) => (
                    <AiFillStar key={index} className="text-yellow-400" />
                  ))}
                </div>
                <div className='mt-2 font-bold'>
                  {hotel.name}
                </div>
                <div className='mt-2 flex justify-between items-center'>
                  <div className='text-sm'>
                    {hotel.city}, {hotel.country}
                  </div>
                  <div className='text-xs text-gray-600'>
                    {hotel.tripAdvisorRating} reviews
                  </div>
                </div>
              </div>
              <hr className="mb-4" />
              <div className="flex justify-between items-center mb-4">
                <div className="flex-1 text-center w-5/12">
                  <div className="text-base font-medium text-gray-900">Check-in</div>
                  <div className="text-sm font-medium text-[#0050b8]">{CheckIn}</div>
                </div>
                <div className="benefits-divider w-1/12 bg-gray-300 min-h-full"></div>
                <div className="flex-1 text-center w-5/12">
                  <div className="text-base font-medium text-gray-900">Check-out</div>
                  <div className="text-sm font-medium text-[#0050b8]">{CheckOut}</div>
                </div>
              </div>
              <hr className="mb-2" />
              <div className="flex justify-center items-center mb-2 text-md text-gray-800">
                <span className="mx-4">
                  <span className="font-semibold text-[#0050b8]">{nights}</span>
                  <span className="text-sm">{nights === 1 ? ' Night' : ' Nights'}</span>
                </span>
                <span className="mx-4">
                  <span className="font-semibold text-[#0050b8]">{adultCount}</span>
                  <span className="text-sm">{adultCount > 1 ? ' Adults' : ' Adult'}</span>
                </span>
                <span className="mx-4">
                  <span className="font-semibold text-[#0050b8]">{childCount}</span>
                  <span className="text-sm">{childCount === 1 ? ' Child' : ' Children'}</span>
                </span>
              </div>
              <hr className="mb-2" />
              <div className="text-base font-medium text-gray-900">
                Room Name:<br />
                <span
                  className={`font-normal text-sm ${roomName === 'Not available for Selected Dates' ? 'text-red-500' : 'text-gray-700'
                    }`}
                >
                  {roomName}
                </span>
              </div>
              <div className="text-base font-medium text-gray-900 mt-2 mb-6">
                Meal Plan:<br />
                <span className="text-gray-700 font-normal text-sm">
                  {roomType && roomType !== ' - ' ? roomType.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) : roomType}
                </span>
              </div>
              <div className="mb-2 text-sm font-semibold text-gray-800 text-right px-2 flex justify-between">
                <span className="text-right w-full">Price:</span>
                <span className="text-gray-700 font-normal line-through ml-1 min-w-20 inline-block">£ {(modifiedGrossPrice / totalCount).toFixed(2)}</span>
              </div>
              <div className="flex justify-end">
                <div className="flex items-center bg-[#f7fffa] px-2 py-1 mb-2 rounded-md min-w-max text-right">
                  {/* <img src="/htag.svg" alt="Save Icon" className="w-4 h-4 mr-1" /> */}
                  <span className="text-sm font-medium text-gray-700">You save:</span>
                  <span className="text-green-600 font-medium text-sm ml-1 min-w-20 inline-block">
                    - £ {(finalDiscountPrice / totalCount).toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="text-right px-2 flex justify-end">
                <div className="text-right">
                  <span className='text-sm font-medium text-gray-700 mb-0'>Per Person</span>
                  <span className="relative inline-flex items-center ml-1 group">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      fill="currentColor"
                      className="bi bi-info-circle cursor-pointer text-gray-500"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg>
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[250px] mb-2 hidden group-hover:block p-3 bg-gray-800 text-white text-xs rounded-lg shadow-md text-center">
                      <span className="text-white">Inc. taxes & charges</span>
                    </div>
                  </span>
                </div>
                <span className="text-xl font-medium text-[#0050b8]" style={{ minWidth: '110px', display: 'inline-block', textAlign: 'right' }}>
                  £ {(roomPriceNew / totalCount).toFixed(2)}
                </span>
              </div>
              <hr className="mb-4" />
              {/* <div className="text-right px-2 -mt-2">
                  <span className="text-xs font-normal text-[#0050b8]">Per person</span>
                </div> */}
              <div className="flex justify-end">
                <div className="flex items-center bg-[#f7fffa] px-2 py-1 mb-2 rounded-md min-w-max text-right">
                  {/* <img src="/htag.svg" alt="Save Icon" className="w-4 h-4 mr-1" /> */}
                  <span className="text-sm font-medium text-gray-700">Total Savings:</span>
                  <span className="text-green-600 font-medium text-sm ml-1 min-w-20 inline-block">
                    - £ {(finalDiscountPrice).toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="text-right px-2 flex justify-end">
                <div className="text-right">
                  <span className='text-sm font-medium text-gray-700 mb-0'>Total Price for {totalCount} people</span>
                  <span className="relative inline-flex items-center ml-1 group">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      fill="currentColor"
                      className="bi bi-info-circle cursor-pointer text-gray-500"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg>
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[250px] mb-2 hidden group-hover:block p-3 bg-gray-800 text-white text-xs rounded-lg shadow-md text-center">
                      <span className="text-white">Inc. taxes & charges</span>
                    </div>
                  </span>
                </div>
                <span className="text-xl font-medium text-[#0050b8]" style={{ minWidth: '110px', display: 'inline-block', textAlign: 'right' }}>
                  £ {(roomPriceNew).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default BookingDetailFormComponent;